export default __webpack_public_path__ + "static/media/(20).57df14f0.jpeg";